export class SidebarObject {
    label = '';
    labels: string[] = [];
    details: string[] = [];
}
